import {ref, watch} from 'vue';
import {useHttpRequest} from "~/composables/useHttpRequest";
import {useAuthService} from "~/composables/useAuthService";
const {notify, addListener, removeListener, removeLocalListenersWithEvent, removeLocalListeners} = useListenerService();
import {useRoute, useRouter} from 'vue-router';
import {endpoints} from "~/network/endpoints.js";

export function useChat() {
  const {toBase64, getFileType} = useCrudConverters();
  const createChatLoading = ref(false);
  const createChatErrors = ref({});

  const router = useRouter();
  const route = useRoute();

  const { setAlertMessage } = useAlertService();
  const { httpRequest } = useHttpRequest();
  const { user } = useAuthService();

  const createChat = async (userIds, name = null) => {

    const data = {
      userIds: userIds,
      name: name,
    };
    createChatLoading.value = true;
    createChatErrors.value = {};

    try {
      const res = await httpRequest(endpoints.chats.create, data);
      if(res.channelUrl) {
        await router.push({name: 'Chat', query: {url: res.channelUrl}});
      } else {
        createChatErrors.value = {global: ['Failed to create chat']};
      }
    } catch (e) {
      console.error("Error:", e);
      createChatErrors.value = e;
    } finally {
      createChatLoading.value = false;
    }
  };

  return {
    createChat,
    createChatLoading,
    createChatErrors,
  };
}

